
import ModeSelect from "./Assets/ModeSelect.svg";
import "./CSS/changementMode.scss";

export default function ModeChange()
{
    return (
        <div className='Page'>
            <h1>Changement de mode</h1>

            <p>
                Pour changer de mode il faudra passer par deux commandes indirectes de l'EF9345 : Les registres TGS et PAT.
            </p>

            <p>
                <img className="modeSelect" src={ModeSelect} alt="Mode Select" />
            </p>

            <p>
                Économie de bout de chandelle ou non, devoir adresser deux commandes n'est franchement pas pratique.<br/>
                Surtout, (et vous devrez y faire attention), ces commandes font bien d'autres choses.<br/>
                Il faudra donc faire particulièrement attention à ne pas faire n'importe quoi avec les autres bits.
            </p>

            <p>
                L'exemple suivant permet de changer de mode sans faire de dégats à coté si vous restez dans une configuration "normale".
            </p>

            <p className="code">
                <pre>
                0|   ;***************************************<br/>
                1|   ;Changement de mode en 40 colonnes long.<br/>
                2|   ;***************************************<br/>
                3|   setMode<br/>
                4|             LD      A,#20+1<br/>
                5|             OUT     (#8F),A         ;R1 select<br/>
                6|             LD      A,%00000000     ;TGS bit 7 & 6 = 0 pour mode 40 long<br/>
                7|             OUT     (#CF),A         ;envoi valeur<br/>
                8|<br/>
                9|             LD      A,#20+0+8       ;R0+EXE<br/>
                10|            OUT     (#8F),A<br/>
                11|            LD      A,%10000001     ;TGS EXE<br/>
                12|            OUT     (#CF),A<br/>
                13|<br/>
                14|            CALL    wait<br/>
                15|<br/>
                16|	;****************************************<br/>
                17|<br/>
                18|            LD      A,#20+1<br/>
                19|            OUT     (#8F),A         ;R1 select<br/>
                20|            LD      A,%00111111     ;bit 7 = 0<br/>
                21|            OUT     (#CF),A<br/>
                22|<br/>
                23|            LD      A,#20+0+8       ;R0+exe<br/>
                24|            OUT     (#8F),A<br/>
                25|            LD      A,%10000011<br/>
                26|            OUT     (#CF),A         ;PAT EXE<br/>
                27|<br/>
                28|            CALL    wait<br/>
                29|<br/>
                30|            RET
                </pre>
            </p>

        </div>
    )
}